import { Workbook, Worksheet } from 'exceljs';
import { each, some } from 'lodash';
import { WorksheetName } from './convertToSheet';

/** Converts Fluent Detailslist items to an excel workbook */
export const prepareCsvFromXlsx = (
  wb: Workbook,
  worksheetName: string = WorksheetName
) => {
  const ws = wb.getWorksheet(worksheetName);
  const hyperColumnList: any[] = [];

  if (!ws) {
    throw new Error(`Worksheet ${worksheetName} not found`);
  }
  each(ws?.columns, c => {
    hyperColumnList.push(c);
    const hasLink = some(c.values, v => {
      //@ts-ignore //hyperlinks do exist
      return v?.valueOf()?.hyperlink;
    });
    if (hasLink) {
      hyperColumnList.push(c.number);
    }
  });
  splitHyperlinkColumnList(ws, hyperColumnList);
};

/** Converts Fluent Detailslist items to an excel workbook */
export const splitHyperlinkColumnList = (
  ws: Worksheet,
  columnList: number[]
) => {
  // For loop needs no let by definition
  for (let i = ws.actualColumnCount; i > 0; i--) {
    const col = ws.getColumn(i);
    if (columnList.includes(col.number)) {
      splitHyperlinkColumn(ws, col.number);
    }
  }
};

/**
 * Separates hyperlink column into text and link columns because CSV does not support
 * hyperlinks.
 */
export const splitHyperlinkColumn = (ws: Worksheet, number: number) => {
  const col = ws.getColumn(number);
  /**
   * The column containing the text content of the hyperlinks.
   * @type {(import('exceljs').Cell|string)[]}
   */
  const textContentList: string[] = [];
  /**
   * The column containing the urls of the hyperlinks.
   * @type {(import('exceljs').Cell|string)[]}
   */
  const hyperlinkList: string[] = [];

  col.eachCell(c => {
    // Update the text content of the text column
    textContentList.push(c.text);

    // Update the text content of the hyperlink column
    // Signpost: handle the title row differently
    if (`${c.row}` === '1') {
      // Update the hyperlink column's first row (header) to include the word 'Link'
      // to differentiate it from the text column.
      hyperlinkList.push(c.text + ' (Link)');
    } else {
      hyperlinkList.push(c.hyperlink || '');
    }
  });

  // Add both generated columns to the spreadsheet
  ws.spliceColumns(number, 1, textContentList);
  ws.spliceColumns(number + 1, 0, hyperlinkList);
};
